import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UsuarioProvider } from "./App/Hooks/global/UsuarioContext";
// import { ClienteProvider } from "./App/Hooks/global/SocketContext";
import "core/fonts/fontface.css";
import "remixicon/fonts/remixicon.css";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider } from "styled-components";
import { Theme } from "theme/Theme";
import { GlobalProvider } from "App/Hooks/global/GlobalContext";
import { GlobalStyled } from "theme/GlobalStyled";
import { ConfigProvider } from "antd";
import { AntConfig } from "theme/antconfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GlobalProvider>
    <UsuarioProvider>
      <ThemeProvider theme={Theme}>
        <ConfigProvider theme={AntConfig}>
          <GlobalStyled>
            <App />
          </GlobalStyled>
        </ConfigProvider>
      </ThemeProvider>
    </UsuarioProvider>
  </GlobalProvider>
);

serviceWorker.register();
